export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'title',
        sortField: 'title',
        type: 'string',
        useInFilter: false,
        defaultSearch: false
    },
    {
        name: 'description',
        sortField: 'description',
        type: 'string',
        useInFilter: false,
        defaultSearch: false
    },
    {
        name: '__slot:link',
        sortField: 'link',
        type: 'string',
        useInFilter: false,
        defaultSearch: false
    },
    {
        name: 'ws',
        sortField: 'ws',
        type: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        sortField: 'wsk',
        type: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'superwsk',
        sortField: 'superwsk',
        type: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: '__slot:ads_count',
        sortField: 'ads_count',
        type: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'avbid',
        sortField: 'avbid',
        type: 'number',
        callback: 'currency',
        dataClass: 'ral avbid',
        useInFilter: true,
    },
]
